import { Component, inject, input, InputSignal, OnDestroy, OnInit } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { ToastService } from '@core/services';
import { PrettyPhonePipe } from '@core/pipes';
import { HelpContact, HelpFeature } from '@legacy-models/strapi/Help';

@Component({
  selector: 'oke-contacts',
  imports: [SvgIconComponent, PrettyPhonePipe],
  templateUrl: './contacts.html',
  styleUrl: './contacts.scss'
})
export class Contacts implements OnInit, OnDestroy {
  private readonly _toastSvc = inject(ToastService);
  readonly $content: InputSignal<HelpFeature> = input.required<HelpFeature>({ alias: 'content' });
  readonly $isOnlyFeature: InputSignal<boolean> = input.required<boolean>({ alias: 'isOnlyFeature' });
  masterContacts: HelpContact[] = [];
  templateContacts: HelpContact[] = [];
  columnsKey: {
    label: string;
    key: keyof HelpContact;
  }[] = [
    { label: 'Name', key: 'name' },
    { label: 'Title', key: 'title' },
    { label: 'Area', key: 'area' },
    { label: 'Group', key: 'group' },
    { label: 'Office', key: 'phoneOffice' },
    { label: 'Mobile', key: 'phoneMobile' },
    { label: 'Email', key: 'email' }
  ];

  constructor() {
    this._toastSvc.dismissAll();
  }

  ngOnInit(): void {
    const contacts = this.$content().contacts;
    if (!contacts?.length) {
      this._toastSvc.alert(
        'Help Center <em>Contacts</em>',
        "The list of ONEOK contacts can't be delivered right now. Please try again later.",
        {
          shouldShowHelpCenter: true,
          shouldShowServiceDesk: true
        }
      );
      return;
    }
    contacts.sort(({ name: nameA }, { name: nameB }) => nameA.localeCompare(nameB));
    this.masterContacts = [...contacts];
    this.templateContacts = [...contacts];
  }

  onSearch({ target: { value: searchedVal } }: { target: HTMLInputElement }): void {
    if (!this.templateContacts) {
      return;
    }
    if (searchedVal.length >= 2) {
      const searchValue = searchedVal.toLowerCase();
      this.templateContacts = this.templateContacts.filter(contact =>
        (Object.keys(contact) as (keyof HelpContact)[]).some(property => {
          const searchableValue = contact[property];
          return searchableValue !== undefined && String(searchableValue).toLowerCase().includes(searchValue);
        })
      );
    } else {
      this.templateContacts = [...this.masterContacts];
    }
  }

  ngOnDestroy(): void {
    this._toastSvc.dismissAll();
  }
}
